import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationParentPage } from './update-registration-parent';

@NgModule({
  declarations: [
    UpdateRegistrationParentPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationParentPage),
  ],
  exports: [
    UpdateRegistrationParentPage
  ]
})
export class UpdateRegistrationParentPageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-parent/update-registration-parent.module.ts